import React from 'react';
import './Template1.css';

const Template2 = ({ formData }) => {
  return (
    <div className="bg-white p-8">
      <header className="mb-6">
        {formData.Details && formData.Details.map((detail, index) => (
          <div key={index} className="header-details">
            {detail.profileImage && (
              <img src={detail.profileImage} alt="Profile" className="w-24 h-24 rounded-full mx-auto" />
            )}
            <h1 className="text-3xl font-bold">{detail.fullName}</h1>
            <p className="text-lg">{detail.jobTitle}</p>
            <p className="text-sm">{detail.address}</p>
            <p className="text-sm">{detail.phoneNumber}</p>
            <p className="text-sm">{detail.email}</p>
            <p className="text-sm">{detail.website}</p>
            <p className="text-sm">{detail.linkedin}</p>
            <p className="text-sm">{detail.github}</p>
          </div>
        ))}
      </header>

      <section className="mb-6">
        {formData.Details && formData.Details.map((detail, index) => (
          <div key={index} className="summary text-sm" dangerouslySetInnerHTML={{ __html: detail.about }} />
        ))}
      </section>

      {formData.Work_flag && formData.experience && (
        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-2">Professional Experience</h2>
          {formData.experience.map((exp, index) => (
            <div key={index} className="job mb-4">
              <h3 className="text-xl font-semibold">{exp.jobRole}</h3>
              <p className="text-sm italic">{exp.companyName}, {exp.companyLocation}</p>
              <p className="text-sm italic">{exp.fromYear} - {exp.toYear}</p>
              <ul className="list-disc ml-5 text-sm">
                <li>{exp.jobDescription}</li>
              </ul>
            </div>
          ))}
        </section>
      )}

      {formData.edu_flag && formData.education && (
        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-2">Education</h2>
          {formData.education.map((edu, index) => (
            <div key={index} className="education-item">
              <p className="text-sm">{edu.degree}</p>
              <p className="text-sm italic">{edu.fromYear} - {edu.toYear}</p>
              <p className="text-sm">{edu.college}, {edu.location}</p>
            </div>
          ))}
        </section>
      )}

      {formData.skill_flag && formData.skills && (
        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-2">Key Skills</h2>
          <ul className="list-disc ml-5 text-sm">
            {formData.skills.map((skill, index) => (
              <li key={index}>{skill.title}</li>
            ))}
          </ul>
        </section>
      )}

      {formData.pro_flag && formData.certifications && (
        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-2">Certifications</h2>
          {formData.certifications.map((cert, index) => (
            <div key={index} className="certification-item">
              <p className="text-sm">{cert.title}</p>
              <p className="text-sm italic">{cert.date}</p>
              <p className="text-sm">{cert.organization}</p>
              {cert.link && (
                <a className="text-sm text-blue-600" href={cert.link}>
                  {cert.link}
                </a>
              )}
            </div>
          ))}
        </section>
      )}

{formData.pro_flag && formData.addprojects && (
        <section className="certifications mb-4">
          <h3 className="text-2xl font-bold mb-2">Projects Developed or Handled</h3>
          {formData.addprojects.map((prodit, index) => (
            <div key={index} className="mb-2">
              <p>{prodit.projectname} - {prodit.projectplatform}</p>
              <div dangerouslySetInnerHTML={{ __html: prodit.description }} />
            </div>
          ))}
        </section>
      )}

      {formData.ach_flag && formData.achivawards && (
        <section className="achievements mb-4">
          <h3 className="text-2xl font-bold mb-2">Achievements & Awards</h3>
          {formData.achivawards.map((ach, index) => (
            <div key={index} className="mb-2">
              <p className="text-base text-gray-600">{ach.achivawards}</p>
            </div>
          ))}
        </section>
      )}

      {formData.add_flag && formData.addinfodatas && (
        <section className="mb-6">
          <h3 className="text-2xl font-bold mb-2">Additional Information</h3>
          {formData.addinfodatas.map((addinfo, index) => (
            <div key={index} className="additional-info-item">
              <p className="text-sm">{addinfo.addinfodata}</p>
            </div>
          ))}
        </section>
      )}

      <p className="watermark">HIREBEEN PREVIEW</p>
    </div>
  );
};

export default Template2;
